import { wrapWithErrorHandling } from '../helpers/wrapWithErrorHandling'
import { HydraCheckIfEmailIsTaken } from './account/GET/checkIfEmailIsTaken'
import { HydraGetCreditCards } from './account/GET/getCreditCards'
import { HydraGetLoginToken } from './account/GET/getLoginToken'
import { HydraGetMe } from './account/GET/getMe'
import { HydraGetMeReferralCode } from './account/GET/getMeReferralCode'
import { HydraGetOrderDetails } from './account/GET/getOrderDetails'
import { HydraGetOrderHistory } from './account/GET/getOrderHistory'
import { HydraGetOrderInvoice } from './account/GET/getOrderInvoice'
import { HydraGetReferralCode } from './account/GET/getReferralCode'
import { HydraGetRegions } from './account/GET/getRegions'
import { HydraGetShippingMethods } from './account/GET/getShippingMethods'
import { HydraGetStoreCredit } from './account/GET/getStoreCredit'
import { HydraGetSubscription } from './account/GET/getSubscription'
import { HydraGetSubscriptions } from './account/GET/getSubscriptions'
import { HydraAddCreditCard } from './account/POST/addCreditCard'
import { HydraChangePassword } from './account/POST/changeAccount'
import { HydraCreateAccount } from './account/POST/createAccount'
import { HydraEditSubscription } from './account/POST/editSubscription'
import { HydraRemoveCreditCard } from './account/POST/removeCreditCard'
import { HydraUpdatePersonalDetails } from './account/POST/updatePersonalDetails'
import {
  HydraCalculateBasicOrder,
  HydraCalculateOrder,
} from './order/calculateOrder'
import { HydraGetPayPalToken } from './order/getPayPalToken'
import { HydraGetSkuAvailability } from './order/getSkuAvailability'
import { HydraPostOrder } from './order/postOrder'
import { hydraAddShipToOption } from './shipToOptions/hydraAddShipToOption'
import { HydraShipByEstimation } from './shipToOptions/hydraShipByEstimation'
import { hydraUpdateShipToOption } from './shipToOptions/hydraUpdateShipToOption'
import { HydraValidateShippingAddress } from './shipToOptions/hydraValidateAddress'
import { HydraCancelSubscription } from './account/DELETE/deleteSubscription'
import { HydraPostSurveyResponse } from './account/POST/sendSurvey'
import { HydraGetWorldPayDDC } from './order/getWorldPayDDC'
import { HydraGetCashPaymentOptions } from './order/getCashPaymentOptions'

export const hydra = wrapWithErrorHandling({
  checkIfEmailIsTaken: HydraCheckIfEmailIsTaken,
  createAccount: HydraCreateAccount,
  addCreditCard: HydraAddCreditCard,
  getCreditCards: HydraGetCreditCards,
  getLoginToken: HydraGetLoginToken,
  getMe: HydraGetMe,
  getMeReferralCode: HydraGetMeReferralCode,
  getReferralCode: HydraGetReferralCode,
  getStoreCredit: HydraGetStoreCredit,
  getRegions: HydraGetRegions,
  removeCreditCard: HydraRemoveCreditCard,
  updatePersonalDetails: HydraUpdatePersonalDetails,
  getSubscription: HydraGetSubscription,
  getSubscriptions: HydraGetSubscriptions,
  changePassword: HydraChangePassword,
  validateShippingAddress: HydraValidateShippingAddress,
  getOrderHistory: HydraGetOrderHistory,
  getOrderDetails: HydraGetOrderDetails,
  getOrderInvoice: HydraGetOrderInvoice,
  addShipToOption: hydraAddShipToOption,
  updateShipToOption: hydraUpdateShipToOption,
  getShippingMethods: HydraGetShippingMethods,
  calculateOrder: HydraCalculateOrder,
  calculateBasicOrder: HydraCalculateBasicOrder,
  shipByEstimation: HydraShipByEstimation,
  postOrder: HydraPostOrder,
  getPayPalToken: HydraGetPayPalToken,
  getSkuAvailability: HydraGetSkuAvailability,
  editSubscription: HydraEditSubscription,
  cancelSubscription: HydraCancelSubscription,
  postSurveyResponse: HydraPostSurveyResponse,
  getWorldPayDDC: HydraGetWorldPayDDC,
  getCashPaymentOptions: HydraGetCashPaymentOptions,
})
